import { useTranslation } from "react-i18next";

export const PhonePreview = () => {
  const { t } = useTranslation();

  return (
    <div className="pp-phone" aria-hidden="true">
      <div className="pp-phone-frame">
        <div className="pp-phone-status">
          <span>9:41</span>
          <span className="pp-phone-status-mark" />
        </div>
        <div className="pp-phone-body">
          <p className="pp-phone-brand">pinpadel</p>
          <div className="pp-phone-card">
            <p className="pp-phone-place">{t("landing.previewPlace")}</p>
            <p className="pp-phone-meta">{t("landing.previewWhen")}</p>
            <div className="pp-phone-row">
              <strong>{t("landing.previewMissing")}</strong>
              <span>{t("landing.previewCount")}</span>
            </div>
            <div className="pp-phone-progress">
              <span />
            </div>
          </div>
          <div className="pp-phone-cta">{t("home.createMatch")}</div>
        </div>
      </div>
    </div>
  );
};
